/**
 * 语音能力默认依赖（T10）。
 *
 * 只提供可注入的缺省值：录音器用 `navigator.mediaDevices` 的默认实现，
 * TTS / 转写适配器暂为 `null`（由设置页 / 上层注入真实适配器）——
 * 缺失时控制器给出结构化「未配置」提示，而不是抛错白屏。
 */

import { createMediaRecorderRecorder } from './recorder';
import type { VoiceDeps } from './types';

export function createDefaultVoiceDeps(): VoiceDeps {
  return {
    tts: null,
    transcribe: null,
    recorder: createMediaRecorderRecorder(),
  };
}